import styled from 'styled-components'

import theme from '../atoms/theme'

const { breakpoints, font } = theme

export const H1 = styled.h1`
  font-weight: 900;
  font-size: 2.8rem;
  margin-bottom: 2.4rem;
  line-height: 1.3;

  @media only screen and ${breakpoints.fromNormalScreen} {
    font-size: ${font.fontSizeLargeDesktop};
    line-height: 1.1;
  }
`

export const H2 = styled.h2`
  font-weight: 900;
  margin-bottom: 1.6rem;
  line-height: 1.2;
  font-size: 2.4rem;

  @media only screen and ${breakpoints.fromNormalScreen} {
    font-size: 3.6rem;
  }
`

export const H3 = styled.h3`
  font-weight: 900;
  font-size: 2rem;
  line-height: 1.3;

  @media only screen and ${breakpoints.fromNormalScreen} {
    font-size: 2.4rem;
    line-height: 1.3;
  }
`

export const H4 = styled.h4`
  font-weight: 600;
  font-size: 1.6rem;
  margin-bottom: 1.6rem;
  line-height: 1.5;

  @media only screen and ${breakpoints.fromNormalScreen} {
    font-size: 1.8rem;
  }
`

export const H5 = styled.h5`
  font-weight: 600;
  font-size: 1.4rem;
  margin-bottom: 1.4rem;
  line-height: 1.5;

  @media only screen and ${breakpoints.fromNormalScreen} {
    font-size: 1.8rem;
  }
`

export const H6 = styled.h6`
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 1.6rem;
  text-transform: uppercase;
  line-height: 1.4;

  @media only screen and ${breakpoints.fromNormalScreen} {
    font-size: 1.4rem;
  }
`

export const ExtendedH3 = styled(H3).attrs({
  as: 'div',
})``

export const ExtendedH4 = styled(H4).attrs({
  as: 'div',
})``

export const ExtendedH6 = styled(H6).attrs({
  as: 'div',
})``

export const Bold = styled.strong`
  font-weight: 900;
`

export const Italic = styled.em`
  font-style: italic;
`

export const Underline = styled.u`
  text-decoration: underline;
`
